import React from 'react';
import PropTypes from 'prop-types';

export default Component => class WithAppState extends React.PureComponent {
    static contextTypes = {
        appStore: PropTypes.object,
    }

    constructor(props, context) {
        super(props);

        this.state = context.appStore.getState();
    }

    componentDidMount() {
        const { appStore } = this.context;
        this.unsubscribe = appStore.subscribe((newState) => {
            this.setState(newState);
        });
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    render() {
        return (
            <Component {...this.props} appState={this.state} />
        );
    }
};



// WEBPACK FOOTER //
// ./src/frontend/components/store/withAppState.jsx